import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { getProfile, getUser } from '@app/app.reducer';
import { select, Store } from '@ngrx/store';
import { isNil } from 'lodash';
import { first, iif, map, of, switchMap } from 'rxjs';

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const store = inject(Store);

  const authToken = toSignal(
    store.pipe(
      select(getUser),
      first(),
      switchMap((user) => iif(() => !isNil(user), of(user), store.select(getProfile))),
      map((userOrProfile) => userOrProfile?.authToken)
    )
  )();

  if (authToken) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', authToken)
    });

    return next(authReq);
  }

  return next(req);
};
